import { render, staticRenderFns } from "./WristbandList.vue?vue&type=template&id=4ff214ba"
import script from "./WristbandList.vue?vue&type=script&lang=js"
export * from "./WristbandList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports